import { ContactInfo, Spacer, Text } from "components";
import * as React from 'react';
export default {
  ContactInfo,
  Spacer,
  Text,
  React
};